import { z } from 'zod';
import { isObject, propertyExists } from 'common/type-guards';

export const UnbindAppInstanceDataModel = z.preprocess(
  val => {
    // backwards compatibility - EMVCo Spec only lists idTokens array property,
    // but previous version of visa-sdk accepted only idToken string
    if (isObject(val) && propertyExists(val, 'idToken')) {
      return { idTokens: [val.idToken] };
    }

    if (typeof val === 'string') {
      return { idTokens: [val] };
    }

    return val;
  },
  z
    .object({
      idTokens: z.string().array().default([])
    })
    .default({ idTokens: [] })
);
